import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getVideos } from "../../../api/endpoints/VideoEndpoints";
import { Paged } from "../../../models/Paged";
import { Video } from "../../../models/Video";

export default function useGetVideosPaginated() {
  return useMutation<Paged<Video>, AxiosError, { page: number }>({
    mutationKey: ["videos"],
    mutationFn: ({ page }) => getVideos(page),
  });
}
